import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getProjectResourcesTags() {
      return getState().tags;
    },
    getProjectResourcesTagsProjectUuid() {
      return getState().projectUuid;
    },
    areProjectResourcesTagsDirty() {
      return getState().isDirty;
    },
    isRetrieveProjectResourcesTagsRequestFailure() {
      return getState().request.isFailure;
    },
    isRetrieveProjectResourcesTagsRequestPending() {
      return getState().request.isPending;
    },
    isRetrieveProjectResourcesTagsRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
